import { useMemo } from 'react';
import { GiphyFetch } from '@giphy/js-fetch-api';
import { useConfigContext } from '@archipro-website/config/bindings/react';

/**
 * Hook to use Giphy's fetch API.
 * @see https://github.com/Giphy/giphy-js/blob/master/packages/fetch-api/README.md
 */
export function useGiphy() {
    const { giphy } = useConfigContext();
    const apiKey = giphy.apiKey;

    return useMemo(() => {
        return new GiphyFetch(apiKey);
    }, [apiKey]);
}
